import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';
import { avvisoCredenziali, COSA_FARE_CREDENZIALI, semaforo } from './ssmateUtentiStato';

const sub = { fontSize: 12, color: '#64748b', marginBottom: 12 };
const inp = { padding: '7px 9px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 13 };

// Credenziali del portale TIM "Digital Sales Mate" (SSMATE). Multi-utente perche' il
// portale limita a 50 ricerche/giorno per utente: piu' account = piu' verifiche al giorno.
export default function SsmateUtentiCard() {
  const [users, setUsers] = useState([]);
  const [nuovo, setNuovo] = useState({ label: '', username: '', password: '' });
  const [busy, setBusy] = useState(false);
  const [provando, setProvando] = useState(null);   // index dell'utente in prova
  const [cfg, setCfg] = useState({ timing_giorni: 90, timing_enabled: true });
  const [cfgDirty, setCfgDirty] = useState(false);

  const load = useCallback(() => {
    axios.get(`${API}/ssmate/users`).then((r) => setUsers(r.data.items || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    axios.get(`${API}/ssmate/config`).then((r) => setCfg(r.data)).catch(() => {});
  }, []);

  const salvaCfg = async () => {
    try { await axios.put(`${API}/ssmate/config`, cfg); setCfgDirty(false); toast.success('Timing SSMATE salvato'); }
    catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  const crea = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/ssmate/users`, {
        label: nuovo.label, username: nuovo.username, password: nuovo.password,
      });
      toast.success(`Utente SSMATE "${nuovo.label || nuovo.username}" aggiunto`);
      setNuovo({ label: '', username: '', password: '' });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore aggiunta utente'); }
    setBusy(false);
  };

  const cambiaPwd = async (u) => {
    const pwd = window.prompt(`Nuova password per "${u.label || u.username}":`);
    if (!pwd) return;
    try {
      await axios.put(`${API}/ssmate/users/${u.index}`, { password: pwd });
      toast.success('Password aggiornata');
      load();
      await provaPwd(u, true);      // la si prova SUBITO: meglio saperlo ora
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  /* Prova di login di UN account: accende il semaforo verde o rosso nella riga. */
  const provaPwd = async (u, dopoCambio = false) => {
    setProvando(u.index);
    const t = toast.loading(dopoCambio ? 'Provo la nuova password sul portale TIM…'
                                       : `Provo le credenziali di "${u.label || u.username}"…`);
    try {
      const r = await axios.post(`${API}/ssmate/users/${u.index}/prova`);
      if (r.data?.ok) toast.success(`Password corretta per "${r.data.utente}"`, { id: t });
      else if (r.data?.esito === 'password_expired') toast.error(`"${r.data.utente}": TIM chiede il cambio password sul portale`, { id: t });
      else if (r.data?.esito === 'bad_credentials') toast.error(`Password rifiutata per "${r.data.utente}"`, { id: t });
      else toast.error(`Portale non raggiungibile (${r.data?.esito})`, { id: t });
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore prova', { id: t }); }
    setProvando(null);
    load();
  };

  const toggle = async (u) => {
    try { await axios.post(`${API}/ssmate/users/${u.index}/toggle`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  const elimina = async (u) => {
    if (!window.confirm(`Eliminare l'utente SSMATE "${u.label || u.username}"?`)) return;
    try { await axios.delete(`${API}/ssmate/users/${u.index}`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  const provaLogin = async () => {
    setBusy(true);
    const t = toast.loading('Apro Edge e provo il login sul portale TIM…');
    try {
      const r = await axios.post(`${API}/ssmate/test-login`);
      if (r.data.ok) toast.success(`Login OK con "${r.data.utente}"`, { id: t });
      else if (r.data.esito === 'bad_credentials') toast.error(`Credenziali errate per "${r.data.utente}"`, { id: t });
      else toast.error(`Portale non raggiungibile (${r.data.esito})`, { id: t });
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore prova login', { id: t }); }
    setBusy(false);
  };

  return (
    <div className="imp-card imp-card--wide">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
        <div className="imp-card-title">Utenti SSMATE (TIM Digital Sales Mate)</div>
        <button className="btn btn-secondary" onClick={provaLogin} disabled={busy || users.length === 0}
          title="Apre Edge e prova il login col primo utente disponibile (non consuma ricerche)">
          Prova login
        </button>
      </div>
      <div style={sub}>
        Credenziali del portale TIM per la verifica del presidio commerciale. Ogni utente ha un
        limite di <b>50 ricerche/giorno</b>: aggiungine più di uno per aumentare le verifiche
        giornaliere (la rotazione è automatica).
      </div>

      {/* Timing: non ri-verificare la stessa azienda entro N giorni (usato dalla verifica massiva) */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', border: '1px solid var(--line)',
        borderRadius: 10, padding: '10px 12px', background: 'var(--surface-2)', margin: '4px 0 14px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600 }}>
          <input type="checkbox" checked={!!cfg.timing_enabled}
            onChange={(e) => { setCfg({ ...cfg, timing_enabled: e.target.checked }); setCfgDirty(true); }} />
          Timing: non ri-verificare entro
        </label>
        <input type="number" min={0} value={cfg.timing_giorni ?? 0} disabled={!cfg.timing_enabled}
          onChange={(e) => { setCfg({ ...cfg, timing_giorni: Number(e.target.value) }); setCfgDirty(true); }}
          style={{ ...inp, width: 80 }} />
        <span style={{ fontSize: 13, color: '#64748b' }}>giorni (per la verifica automatica/massiva)</span>
        <button className="btn btn-primary" onClick={salvaCfg} disabled={!cfgDirty} style={{ marginLeft: 'auto' }}>
          Salva timing
        </button>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 14 }}>
        <thead>
          <tr style={{ textAlign: 'left', color: '#64748b' }}>
            <th style={{ padding: '6px 4px' }}>Etichetta</th>
            <th style={{ padding: '6px 4px' }}>Username</th>
            <th style={{ padding: '6px 4px' }}>Password</th>
            <th style={{ padding: '6px 4px' }}>Stato</th>
            <th style={{ padding: '6px 4px' }}>Azioni</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.index} style={{ borderTop: '1px solid #f1f5f9' }}>
              <td style={{ padding: '6px 4px', fontWeight: 600 }}>{u.label || '—'}</td>
              <td style={{ padding: '6px 4px' }}>{u.username}</td>
              <td style={{ padding: '6px 4px', color: u.has_password ? '#334155' : '#b91c1c' }}>
                {u.has_password ? '••••••••' : 'mancante'}
              </td>
              <td style={{ padding: '6px 4px', color: u.enabled === false ? '#b91c1c' : '#15803d' }}>
                {u.enabled === false ? 'disabilitato' : 'attivo'}
                {avvisoCredenziali(u) && (
                  <div style={{ color: 'var(--err)', fontWeight: 600, marginTop: 2 }}
                       title={COSA_FARE_CREDENZIALI}>
                    ⚠ {avvisoCredenziali(u)}
                  </div>
                )}
                {!avvisoCredenziali(u) && semaforo(u) && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 3,
                                fontSize: 11.5, color: semaforo(u).colore, fontWeight: 600 }}>
                    <span style={{ width: 8, height: 8, borderRadius: '50%',
                                   background: semaforo(u).colore, display: 'inline-block' }} />
                    {semaforo(u).testo}
                  </div>
                )}
              </td>
              <td style={{ padding: '6px 4px', display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                <button className="btn btn-secondary" onClick={() => cambiaPwd(u)}>Password</button>
                <button className="btn btn-secondary" onClick={() => provaPwd(u)}
                        disabled={provando === u.index}
                        title="Apre Edge e prova il login di questo account (non consuma ricerche)">
                  {provando === u.index ? 'Provo…' : 'Prova'}
                </button>
                <button className="btn btn-secondary" onClick={() => toggle(u)}>{u.enabled === false ? 'Attiva' : 'Disattiva'}</button>
                <button className="btn btn-secondary" style={{ color: '#b91c1c' }} onClick={() => elimina(u)}>Elimina</button>
              </td>
            </tr>
          ))}
          {users.length === 0 && (
            <tr><td colSpan={5} style={{ padding: '8px 4px', color: '#94a3b8' }}>Nessun utente SSMATE configurato.</td></tr>
          )}
        </tbody>
      </table>

      <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 14 }}>
        <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 10 }}>Nuovo utente SSMATE</div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <label style={{ fontSize: 11, color: '#64748b' }}>Etichetta</label>
            <input style={inp} placeholder="es. Mario R." value={nuovo.label}
                   onChange={(e) => setNuovo({ ...nuovo, label: e.target.value })} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <label style={{ fontSize: 11, color: '#64748b' }}>Username</label>
            <input style={inp} placeholder="username portale" value={nuovo.username}
                   onChange={(e) => setNuovo({ ...nuovo, username: e.target.value })} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <label style={{ fontSize: 11, color: '#64748b' }}>Password</label>
            <input style={inp} type="password" placeholder="password portale" value={nuovo.password}
                   onChange={(e) => setNuovo({ ...nuovo, password: e.target.value })} />
          </div>
        </div>
        <button className="btn btn-primary" style={{ marginTop: 12 }}
                disabled={busy || !nuovo.username || !nuovo.password} onClick={crea}>
          Aggiungi utente
        </button>
      </div>
    </div>
  );
}
